var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"depressed":"","large":"","color":"white"},on:{"click":_vm.toggleNotesDrawerState},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-icon',[_vm._v(" mdi-note-outline ")]),_vm._v(" "),_c('span',{staticClass:"tw-hidden md:tw-block"},[_vm._v("Notes")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }